<template>
  <RouterLink v-if="to" :to="to" :class="classes" v-bind="$attrs">
    <div class="flex items-center gap-2 mx-auto">
      <component :is="iconElement" class="w-4 h-4" />
      <slot />
    </div>
  </RouterLink>
  <a v-else-if="href" :href="href" :class="classes" v-bind="$attrs">
    <div class="flex items-center gap-2 mx-auto">
      <component :is="iconElement" class="w-4 h-4" />
      <slot />
    </div>
  </a>
  <button v-else :class="classes" v-bind="$attrs" type="button" v-on="$attrs">
    <div class="flex items-center gap-2 mx-auto">
      <component :is="iconElement" class="w-4 h-4" />
      <slot />
    </div>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { brandIconMapping } from "@/icons/brand-icon-mapping";
import { iconMappingMicro } from "@/icons/icon-mapping-micro";
import { type RouteLocation } from "@/router/types";

const classes = computed(() => {
  return [
    "border border-gray-200 bg-gray-50 rounded text-gray-700 py-2 hover:bg-blue-100 hover:text-blue-700 hover:border-blue-300 transition-colors text-sm font-bold flex items-center justify-center",
    props.variant === "primary" &&
      "border-blue-600 bg-blue-500 rounded text-white py-2 hover:bg-blue-700 transition-colors text-sm font-bold flex px-3 items-center justify-center",
    props.variant === "negative" &&
      "border-red-400 bg-red-200 rounded text-red-600 py-2 hover:bg-red-300 hover:text-red-700 hover:border-red-500 transition-colors text-sm font-bold flex px-3 items-center justify-center",
  ];
});

const props = defineProps<{
  to?: RouteLocation;
  href?: string;
  icon?: keyof typeof brandIconMapping | keyof typeof iconMappingMicro;
  variant?: "primary" | "negative";
}>();

const iconElement = computed(() => {
  if (props.icon && props.icon in brandIconMapping) {
    return brandIconMapping[props.icon as keyof typeof brandIconMapping];
  }
  if (props.icon && props.icon in iconMappingMicro) {
    return iconMappingMicro[props.icon as keyof typeof iconMappingMicro];
  }
  return null;
});
</script>
